import { useState } from 'react';

import { Button } from '@components/button';
import { CancelationModal } from '@components/modals/CancelationModal/CancelationModal';
import { DeclinationModal } from '@components/modals/DeclinationModal/DeclinationModal';
import { QuoteStatusChangeReason } from '@models/quoteStatusChange';
import { QuoteStatusId } from '@models/quotes';

export type ViewStatusChangeReasonButtonProps = {
  reasonData: QuoteStatusChangeReason;
  newQuoteStatusId: QuoteStatusId;
  policyNumber?: string;
};

/**
 * Internal-only tertiary ("text") button rendered on Declined / Cancelled milestone cards.
 * Opens the existing declination/cancellation modal in read-only mode, populated with the
 * reasons captured when the quote was declined or cancelled.
 */
export const ViewStatusChangeReasonButton = ({
  reasonData,
  newQuoteStatusId,
  policyNumber,
}: ViewStatusChangeReasonButtonProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const isDeclined = newQuoteStatusId === QuoteStatusId.Declined;

  const handleCloseModal = () => setModalOpen(false);

  return (
    <>
      <Button
        variant='text'
        sx={{ paddingLeft: '0px', marginTop: 0.5 }}
        onClick={() => setModalOpen(true)}
        disableRipple
      >
        {isDeclined ? 'View Declination Reasons' : 'View Cancellation Reasons'}
      </Button>

      {isDeclined ? (
        <DeclinationModal
          isReadOnly
          isOpen={modalOpen}
          onCloseModal={handleCloseModal}
          policyNumber={policyNumber}
          reasonData={reasonData}
        />
      ) : (
        <CancelationModal
          isReadOnly
          isOpen={modalOpen}
          onCloseModal={handleCloseModal}
          policyNumber={policyNumber}
          reasonData={reasonData}
        />
      )}
    </>
  );
};
